/* Misan Oyuncak — Wishlist (localStorage) */
(function () {
  'use strict';

  var KEY = 'misan_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function saveList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function getHandle(card) {
    var href = card.getAttribute('href') || '';
    var match = href.match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  }

  function updateHeaderBadge() {
    var count = getList().length;
    document.querySelectorAll('.misan-wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('.misan-wishlist-btn').forEach(function (el) {
      el.classList.toggle('has-items', count > 0);
      el.setAttribute('aria-label', count > 0 ? ('Favorilerim (' + count + ')') : 'Favorilerim');
    });
  }

  function updateCardButtons() {
    var list = getList();
    document.querySelectorAll('.misan-prod-card__wish').forEach(function (btn) {
      var card = btn.closest('[href*="/products/"]');
      if (!card) return;
      var handle = getHandle(card);
      if (!handle) return;
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function toggleItem(btn) {
    var card = btn.closest('[href*="/products/"]');
    if (!card) return;
    var handle = getHandle(card);
    if (!handle) return;

    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveList(list);
    updateHeaderBadge();
    updateCardButtons();
  }

  /* Event delegation — product card wish buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.misan-prod-card__wish');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleItem(btn);
  });

  /* Init on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateHeaderBadge();
      updateCardButtons();
    });
  } else {
    updateHeaderBadge();
    updateCardButtons();
  }
})();
